import { render, staticRenderFns } from "./OtherCalculation.vue?vue&type=template&id=2374f7df&"
import script from "./OtherCalculation.vue?vue&type=script&lang=js&"
export * from "./OtherCalculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports